import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse, AzureLab } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const roomAzureApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAzureLabs: builder.query<ApiResponse<AzureLab[]>, { roomId?: string }>({
      query: ({ roomId }) => ({
        url: 'rooms/cloud/azure/labs',
        method: 'GET',
        params: { roomId },
      }),
      providesTags: [RTKQueryTag.CloudAzureLabs],
    }),
    joinLab: builder.mutation({
      query: (body: { taskId: string; roomId: string }) => ({
        url: 'rooms/cloud/azure/labs',
        method: 'POST',
        body,
      }),
      invalidatesTags: [RTKQueryTag.Company, RTKQueryTag.CloudAzureLabs],
    }),
    leaveLab: builder.mutation({
      query: (body: { taskId: string; roomId: string; labId?: string }) => ({
        url: 'rooms/cloud/azure/labs',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: [RTKQueryTag.Company, RTKQueryTag.CloudAzureLabs],
    }),
    runAction: builder.mutation<AzureLab | undefined, unknown>({
      query: (body: { taskId: string; roomId: string; labId?: string; actionLabel?: string }) => ({
        url: 'rooms/cloud/azure/labs/action',
        method: 'POST',
        body,
      }),
      transformResponse: (response: ApiResponse<AzureLab>) => response.data,
      invalidatesTags: [RTKQueryTag.Company, RTKQueryTag.CloudAzureLabs],
    }),
  }),
});

export const { useGetAzureLabsQuery, useJoinLabMutation, useLeaveLabMutation, useRunActionMutation } =
  roomAzureApiSlice;
